import React /* , { lazy, Suspense } */ from 'react';
import { Routes, Route } from 'react-router-dom';
import 'styles/css/App.css';

//tratamento e redirecionamento
import Entrance from 'js/components/Entrance/Entrance';

//promoções consumo deslogado
import ApplessPromotion from 'js/components/ApplessPromotions/ApplessPromotion';

//PowerBI para usuários
import Reports from 'js/components/ReportsBI/Reports';

//Confirmação de dados do usuário
import DataConfirmation from 'js/components/DataConfirmation/DataConfirmation';

//Links do estabelecimento
import EstablishmentLinks from 'js/components/EstablishmentLinks';

import Drawer from 'js/containers/Drawer/Drawer';
import ApplessVoucher from 'js/components/ApplessPromotions/ApplessVoucher';

/* //import Loading from "js/containers/Loading/Loading";
const CodeInput = lazy(() => import("js/components/LoginForms/CodeInput"));
const UserForm = lazy(() => import("js/components/LoginForms/UserForm"));

//Menu
const Drawer = lazy(() => import("js/containers/Drawer/Drawer")); */

//const renderLoader = () => <Loading />;

export default function App() {
  return (
    <Routes>
      {/* <Route exact path="/login" element={<PhoneInput />} />

      <Route exact path="/inserirCodigo" element={<CodeInput />} />

      <Route exact path="/cadastroUsuario" element={<UserForm />} /> */}

      <Route exact path="/entrance" element={<Entrance />} />

      <Route exact path="/promocao" element={<ApplessPromotion />} />

      <Route exact path="/voucher" element={<ApplessVoucher />} />

      <Route exact path="/reports-bi" element={<Reports />} />

      <Route exact path="/confirmar-dados" element={<DataConfirmation />} />

      <Route exact path="/estabelecimento-links" element={<EstablishmentLinks />} />

      {/* <Suspense fallback={renderLoader()}> */}

      <Route path="/*" element={<Drawer />} />
      {/* </Suspense> */}
    </Routes>
  );
}
